module.exports = __webpack_public_path__ + "static/media/client-Light.29a4b6db.svg";